/**
 * CSAM clearance from permission-service user credentials.
 *
 * Canonical API fields are ``csam_limited_user`` / ``csam_verifier`` (TR-3175).
 * ``csam_viewer`` / ``csam_reviewer`` stay as fallbacks for one release.
 * DB columns remain ``can_view_csam`` / ``csam_reviewer``.
 *
 * Verifier is a superset of limited-user.
 */
export type CsamCredentials = {
  csamLimitedUser: boolean;
  csamVerifier: boolean;
};

function truthy(value: unknown): boolean {
  return Boolean(value);
}

export function csamCredentialsFromUser(user: unknown): CsamCredentials {
  const record = user && typeof user === 'object' ? (user as Record<string, unknown>) : {};
  const csamVerifier =
    truthy(record.csam_verifier) || truthy(record.csam_reviewer);
  const csamLimitedUser =
    truthy(record.csam_limited_user) ||
    truthy(record.csam_viewer) ||
    truthy(record.can_view_csam) ||
    csamVerifier;
  return { csamLimitedUser, csamVerifier };
}
